exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nimg[data-v-203c96db] {\n  height: 70px;\n}\n", ""]);

// exports
